var Handlebars = require("/home/travis/build/thelounge/lounge/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "			<tr>\n				<td class=\"hostmask\">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.hostmask : depth0), depth0))
    + "</td>\n				<td class=\"banned_by\">"
    + ((stack1 = __default(require("/home/travis/build/thelounge/lounge/client/js/libs/handlebars/parse.js")).call(alias1,(depth0 != null ? depth0.banned_by : depth0),{"name":"parse","hash":{},"data":data})) != null ? stack1 : "")
    + "</td>\n				<td class=\"banned_at\">"
    + ((stack1 = __default(require("/home/travis/build/thelounge/lounge/client/js/libs/handlebars/localetime.js")).call(alias1,(depth0 != null ? depth0.banned_at : depth0),{"name":"localetime","hash":{},"data":data})) != null ? stack1 : "")
    + "</td>\n			</tr>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<table class=\"ban-list\">\n	<thead>\n		<tr>\n			<th class=\"hostmask\">Banned</th>\n			<th class=\"banned_by\">Banned By</th>\n			<th class=\"banned_at\">Banned At</th>\n		</tr>\n	</thead>\n	<tbody>\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.bans : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	</tbody>\n</table>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./client/views/actions/ban_list.tpl
// module id = 217
// module chunks = 0